import { Button, Modal, ModalHeader, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useDeleteChildModalStore from "./useDeleteChildModalStore"
import useEditChildProfileModalStore from "./useEditChildProfileModalStore"
import { useRemoveChildMutation } from "../../../networking/families/mutations"
import { useFamilyQuery, useUserQuery } from "../../../networking/queries"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"

const DeleteChildModal = () => {
  const { isOpen, onClose, childUserId } = useDeleteChildModalStore()
  const { data: family } = useFamilyQuery()
  const { setSelectedUserId } = useFamilyUserSelectStore()
  const { onClose: closeEditChildProfileModal } =
    useEditChildProfileModalStore()
  const removeChildMutation = useRemoveChildMutation()
  const { user } = useUserQuery()
  const { t } = useTranslation()

  const handleDeleteChild = async () => {
    if (!childUserId || !family || !user) return
    await removeChildMutation.mutateAsync({
      childId: childUserId,
      familyId: family.id,
    })
    onClose()
    closeEditChildProfileModal()
    setSelectedUserId(user.id)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "min(350px, 95vw)" }}
    >
      <ModalHeader
        title={t("PPC_ARE_YOU_SURE")}
        onClose={onClose}
        showBorderBottom
      />
      <div className="flex flex-col gap-4 p-6 pt-4 ">
        <Typography variant="bodyBold">{t("DCH_CONFIRM")}</Typography>
        <div className="flex flex-row justify-between gap-4 items-center">
          <Button
            onClick={onClose}
            text={t("QB_CANCEL")}
            fullWidth
            buttonType="secondary"
          />
          <Button
            text={t("ECP_DELETE_CHILD")}
            onClick={handleDeleteChild}
            fullWidth
            buttonType="redPrimary"
            isLoading={removeChildMutation.isLoading}
          />
        </div>
      </div>
    </Modal>
  )
}

export default DeleteChildModal
